import React from "react";
import { useNavigate } from "react-router-dom";
import { createHeroSection } from "adminApi/WebsiteSettingsApi/HeroSectionApi";
import { validateForm } from "utils/validation";
import { HeroSectionRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddHeroSectionForm from "./Componates/AddHeroSectionForm";
import fields from "../json/HeroSectionListFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import { getImageUrl } from "utils/imageHelper";
import { setRefetchTrigger } from "Hooks/useRefetchOnReturn";

const AddHeroSection = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Create navigation function with refetch trigger
  const navigateWithRefetch = setRefetchTrigger(navigate, 'heroSection');

  // Initialize default form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.accessor]: "" }), {});

  const { values, errors, handleChange, handleFileChange } = useFormChange(
    initialValues,
    HeroSectionRules
  );

  const { loading, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => {
        formData.append(key, val ?? "");
      });
      return await createHeroSection({ data: formData });
    },
    (vals) => validateForm(vals, HeroSectionRules),
    navigateWithRefetch,
    "Hero Section Created successfully"
  );


  return (
    <>
      {loading && <Spinner isSpinner={true} />}
      <AddHeroSectionForm
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleFileChange={handleFileChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        imagePreview={values.background_imagePreview || getImageUrl(values.background_image)}
        loading={loading}
      />
    </>
  );
};

export default AddHeroSection;
